import { MCLogger } from '@mc/logger';

import { parseJsonData } from '../parseJson';
import { initTallyFields } from './constants';
import { FormId, Message, MessageEvent, TallyEventType, TallyLifecycleEventType, TallyMessageField } from './typings';
export * from './constants';
export type TallyIdKeysType = 'ja-JP' | 'en-US';

class TallyMessageWatch {
  private forms: Map<FormId, TallyEventType>;
  static instance: TallyMessageWatch;

  constructor() {
    this.forms = new Map();
    if (!TallyMessageWatch.instance) {
      TallyMessageWatch.instance = this;
    }
    return TallyMessageWatch.instance;
  }

  /**
   * 注册 postMessage 监听
   * @param {Message.origin} origin
   * @param {Message.data} data
   * @returns void 0
   */
  registerPostMessageHandle = (tallyMsg: Message): void => {
    const { origin, data } = tallyMsg;
    try {
      // NOTE: Tally 自定义域名配置比较繁琐，如果没有额外的需求可以直接用默认地址
      if (origin === `https://${process.env.TALLY_DOMAIN}` || origin === 'https://tally.so') {
        if (data?.startsWith('{"event')) {
          MCLogger.log('👀 ------------>>> tally postMessage event:', tallyMsg);
          const { event, payload } = parseJsonData(data) as MessageEvent;
          const { formId, fields } = payload;
          const forceEvent = this.forms.get(formId);
          if (forceEvent) {
            this.forms.set(formId, {
              ...forceEvent,
              memorizeState: fields,
            });
            forceEvent?.[event]?.();
          }
        }
      }
    } catch (error) {
      MCLogger.error('😭 tally postMessage event parse error', error);
    }
  };

  /**
   * 获取消息事件
   * @param {FormId} formId
   */
  getMessageEventFieldByFormId = (formId: FormId): Array<TallyMessageField> => {
    return this.forms.get(formId)?.memorizeState || [];
  };

  /**
   * 监听 Tally 生命周期事件
   * @param {FormId} formId
   * @param {TallyLifecycleEventType} LifecycleEvents
   * @returns void 0
   */
  watch = (formId: FormId, LifecycleEvents: TallyLifecycleEventType): void => {
    this.forms.set(formId, {
      ...LifecycleEvents,
      memorizeState: initTallyFields,
    });
  };

  /**
   * 取消监听 Tally 生命周期事件
   * @param {FormId} formId
   * @returns void 0
   */
  unwatch = (formId: FormId): void => {
    this.forms.delete(formId);
  };
}

export const TallyMessageWatcher = new TallyMessageWatch();
